const parseSupplierInfo = (supplierInfo) => {
  if (!supplierInfo) return {};
  if (typeof supplierInfo === "object") return supplierInfo;
  if (typeof supplierInfo === "string") {
    try {
      return JSON.parse(supplierInfo);
    } catch {
      return {};
    }
  }
  return {};
};

const isDecorationPurchaseOrder = (row = {}) => {
  const info = parseSupplierInfo(row?.supplierInfo);
  const typeValues = [row?.purchaseOrderType, info?.type].map((value) =>
    String(value || "").trim()
  );
  if (
    typeValues.some((type) =>
      ["Different_supplier_decoration", "Same_supplier_decoration", "decoration"].includes(type)
    )
  ) {
    return true;
  }
  if (info?.decoratorId != null && String(info.decoratorId).trim()) return true;
  if (Array.isArray(info?.charges) && info.charges.some((charge) => charge?.decoratorId != null)) {
    return true;
  }
  return false;
};

const buildSearchableText = (row = {}) => {
  const supplierInfo = parseSupplierInfo(row?.supplierInfo);
  return [
    row?.poNumber,
    row?.orderId,
    row?.salesOrderId,
    supplierInfo?.supplierName,
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();
};

export const filterReceivingQueueRows = ({ rows = [], query = "" }) => {
  const q = String(query || "").trim().toLowerCase();
  const visibleRows = (Array.isArray(rows) ? rows : []).filter(
    (row) => !isDecorationPurchaseOrder(row)
  );
  if (!q) return visibleRows;
  return visibleRows.filter((row) => buildSearchableText(row).includes(q));
};

export const buildReceivedHistoryDisplayRows = ({
  purchaseOrders = [],
  historyRows = [],
  query = "",
}) => {
  const historyByPoId = new Map(
    (Array.isArray(historyRows) ? historyRows : []).map((historyRow) => [
      Number(historyRow?.poId),
      historyRow,
    ])
  );

  const mergedRows = (Array.isArray(purchaseOrders) ? purchaseOrders : [])
    .filter((row) => !isDecorationPurchaseOrder(row))
    .filter((row) => historyByPoId.has(Number(row?.id)))
    .map((row) => ({
      ...row,
      receiptHistory: historyByPoId.get(Number(row?.id)),
    }))
    .sort((left, right) => {
      const rightTs = new Date(right?.receiptHistory?.lastReceivedAt || 0).getTime();
      const leftTs = new Date(left?.receiptHistory?.lastReceivedAt || 0).getTime();
      return rightTs - leftTs;
    });

  return filterReceivingQueueRows({ rows: mergedRows, query });
};

export const countReceiptHistoryTrackedBoxes = (history = {}) => {
  const receipts = Array.isArray(history?.receipts) ? history.receipts : [];
  const trackedRefs = new Set();
  let untrackedContainers = 0;

  receipts.forEach((receipt) => {
    const rawBoxRef = String(receipt?.boxRef || "").trim();
    if (rawBoxRef) {
      trackedRefs.add(rawBoxRef.toLowerCase());
      return;
    }

    const containerCount = Number(receipt?.containerCount);
    if (Number.isFinite(containerCount) && containerCount > 0) {
      untrackedContainers += containerCount;
      return;
    }

    untrackedContainers += 1;
  });

  return trackedRefs.size + untrackedContainers;
};
